import axios from 'axios'
import { getURL } from '../../utils'

export const search = async function (searchText) {
  const url = '/freshdesk/api/v2/search/solutions?term=' + searchText
  axios.defaults.withCredentials = true
  return axios.get(getURL(url))
}

export const getArticleURL = async function (item) {
  const portals = {
    '35000062767': 'https://software.support.flexlink.io',
    '35000062857': 'https://standardcontrols.support.flexlink.io',
    '35000062858': 'https://robotics.support.flexlink.io',
    '35000062856': 'https://conveyor.support.flexlink.io',

  }
  // /api/v2/solutions/categories/
  axios.defaults.withCredentials = true
  const url = '/freshdesk/api/v2/solutions/categories/' + item.category_id
  let portalId = ''
  await axios.get(getURL(url))
    .then(res => {
      if (res.data) {
        const vip = res.data.visible_in_portals
        if (vip && Array.isArray(vip) && vip.length > 0) {
          for (const v of vip) {
            if (portals.hasOwnProperty(v)) {
              portalId = v
              break
            }
          }
        }
      }
    })
    .catch(err => {
      console.log('[ERROR]', err)
    })
  // TODO: create 404 page if portal id not found
  return portals[portalId] + '/support/solutions/articles/' + item.path
}

export const widget = function () {
  window.fwSettings = {
    'widget_id': 35000001094
  }
  const f = function () {
    if ('function' != typeof window.FreshworksWidget) {
      const n = function () {
        n.q.push(arguments)
      }
      n.q = [], window.FreshworksWidget = n
    }
  }

  f()

  const script = window.document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('src', 'https://widget.freshworks.com/widgets/35000001094.js')
  script.async = true
  script.defer = true
  window.document.body.append(script)
}
